import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { BomInfoForDetailView } from './bom-detail-view-for-so';


export class BOMDetailViewResponse extends GlobalResponseObject {
    data?: BomInfoForDetailView[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /BomInfoForDetailView
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: BomInfoForDetailView[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

 